module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAASUlEQVR42u3XsQ0AIAgEQNZwPxtnclhttTJByiP5llxBCEQctUZb2URFAVxNZ38HAAAAAKB6ZQN8ASpmBQAAAAAAAODnOc3eAxtKwzm7pBlSgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/captadas_pluri_con.png
// module id = qRPz
// module chunks = 0